var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapContainer"},[(_vm.hasEnd)?_c('p',[_vm._v("Parabéns!Você finalizou sua rota!")]):_vm._e(),(_vm.hasLink)?_c('div',{staticClass:"imgCont",on:{"click":function($event){return _vm.ImgClose()}}},[_c('img',{attrs:{"src":_vm.currentLink}})]):_vm._e(),_c('l-map',{ref:"map",staticStyle:{"height":"70vh"},attrs:{"zoom":_vm.zoom,"center":[
      _vm.currentPoint.lat ||
        _vm.position.lat ||
        _vm.userLocation.lat ||
        _vm.defaultLocation.lat,
      _vm.currentPoint.lng ||
        _vm.position.lng ||
        _vm.userLocation.lng ||
        _vm.defaultLocation.lng,
    ]}},[_c('l-tile-layer',{attrs:{"url":_vm.tileProvider.url,"attribution":_vm.tileProvider.attribution}}),_c('l-circle-marker',{attrs:{"lat-lng":_vm.userPosition,"radius":_vm.radius,"color":"red"}}),(!_vm.hasEnd)?_c('l-marker',{attrs:{"visible":"","icon":_vm.icon,"lat-lng":_vm.currentPoint}}):_vm._e()],1),(!_vm.hasEnd)?_c('button',{on:{"click":function($event){return _vm.PointPP()}}},[_vm._v("Iniciar Encontro!")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }